// import DatePickerLocale from 'rmc-date-picker/lib/locale/zh_CN';

export default {
  okText: 'ç¡®å®',
  dismissText: 'åæ¶',
  extra: 'è¯·éæ©',
  // DatePickerLocale,
  year: 'å¹´',
  month: 'æ',
  day: 'æ¥',
  hour: 'æ¶',
  minute: 'å',
  am: 'ä¸å',
  pm: 'ä¸å'
};